import React from 'react';

type Props = React.SVGProps<SVGSVGElement> & {
  color?: string;
  size?: number;
};

export default function Unchecked({
  color,
  size = 32,
  width,
  height,
  style,
  className,
  ...props
}: Props) {
  const finalWidth = width ?? size;
  const finalHeight = height ?? size;
  const finalStyle: React.CSSProperties | undefined = color
    ? { ...style, color }
    : style;
  const finalClassName = ['text-[#FACC15]', className]
    .filter(Boolean)
    .join(' ');
  return (
    <svg
      width={finalWidth}
      height={finalHeight}
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
      focusable='false'
      style={finalStyle}
      className={finalClassName}
      {...props}
    >
      <path
        d='M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z'
        fill='currentColor'
        fillOpacity='0.1'
      />
      <g clipPath='url(#clip0_319_1173)'>
        <path
          d='M15.9997 13.3334V16M15.9997 18.6667H16.0063M22.6663 16C22.6663 19.6819 19.6816 22.6667 15.9997 22.6667C12.3178 22.6667 9.33301 19.6819 9.33301 16C9.33301 12.3181 12.3178 9.33337 15.9997 9.33337C19.6816 9.33337 22.6663 12.3181 22.6663 16Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_319_1173'>
          <rect
            width='16'
            height='16'
            fill='white'
            transform='translate(8 8)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}